import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchGroups } from "./similarWordsService";
import { BASE_ROOT } from "../../../../common/api_constant";
import "./SimilarWords.css";

const SimilarWordsListPage = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      console.log("[SimilarWords] BASE_ROOT:", BASE_ROOT);
      const res = await fetchGroups({ search: search || undefined });
      console.log("[SimilarWords] API result:", res);
      if (res.status === 200 && res.data) {
        const list = res.data.data || (Array.isArray(res.data) ? res.data : []);
        console.log("[SimilarWords] items sample:", list.slice(0, 2).map(g => ({ id: g.id, title: g.title, imageUrl: g.imageUrl })));
        setGroups(list);
      } else { setGroups([]); }
      setLoading(false);
    };
    load();
  }, [search]);

  return (
    <>
      <Navbar />
      <div className="sw-page">
        <h1 className="sw-title">🔤 Similar Words</h1>
        <p className="sw-subtitle">Master commonly confused words and homophones.</p>

        <div className="sw-filters">
          <input
            className="sw-search"
            type="text"
            placeholder="Search similar words..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {loading ? (<p className="sw-loading">Loading...</p>) : groups.length === 0 ? (<p className="sw-empty">No word groups available yet.</p>) : (
          <div className="sw-grid">
            {groups.map((g) => (
              <div key={g.id} className="sw-card" onClick={() => navigate(`/study/similar-words/${g.id}`)}>
                {g.imageUrl && (
                  <img
                    src={`${BASE_ROOT}${g.imageUrl}`}
                    alt={g.title}
                    onLoad={() => console.log("[SimilarWords] Image OK:", `${BASE_ROOT}${g.imageUrl}`)}
                    onError={() => console.error("[SimilarWords] Image FAIL:", `${BASE_ROOT}${g.imageUrl}`)}
                    style={{ width: "calc(100% + 40px)", height: 130, objectFit: "contain", background: "#f5f5f5", borderRadius: "16px 16px 0 0", margin: "-20px -20px 14px -20px", display: "block" }}
                  />
                )}
                <h3 className="sw-card-title">{g.title}</h3>
                <span className="sw-card-count">{g.wordCount || 0} words</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default SimilarWordsListPage;
